import React from 'react'
import PropTypes from 'prop-types'
import texts from '../../../common/texts.json'
import './AddToCart.css'

const AddToCart = ({ disabled, onClick }) =>
  disabled ? (
    <button
      disabled
      id="addProductToCartDisabled"
      className="walmart-add-cart-blue-button-out-of-stock add-to-cart add-to-cart--disabled"
      type="button"
    >
      {texts.PRODUCT_DETAIL.SOLD_OUT}
    </button>
  ) : (
    <button
      id="addProductToCart"
      className="walmart-add-cart-blue-button text-center cp-no-select add-to-cart"
      onClick={onClick}
      onKeyPress={onClick}
      type="button"
    >
      {texts.PRODUCT_DETAIL.ADD_TO_CART}
    </button>
  )

AddToCart.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default AddToCart
